var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 10.667V14.3337C14.9998 14.7003 15.0331 14.667 14.6664 14.667H1.33317C0.966502 14.667 0.999811 14.7003 0.999811 14.3337V10.667",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.33398V10.6673",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3327 8.00098L7.99935 11.3343L4.66602 8.00098",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })));
}

export default SvgIconDownload;